import "./footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer_text">© 2024 - Fabien Costa </p>
    </footer>
  );
};

export default Footer;
